import { render, staticRenderFns } from "./NormCompute.vue?vue&type=template&id=90cb06f8&scoped=true"
import script from "./NormCompute.vue?vue&type=script&lang=js"
export * from "./NormCompute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cb06f8",
  null
  
)

export default component.exports